module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "successHolder"
  }, [_c('div', {
    staticClass: "drpAllImgSvg errorImg"
  }), _vm._v(" "), _c('div', {
    staticClass: "submittedTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.front_page.oops_error_msg")))])]), _vm._v(" "), _c('div', {
    staticClass: "footerHolder"
  }, [_c('div', {
    staticClass: "supportText"
  }, [_vm._v(_vm._s(_vm.$t("message.front_page.support_msg")))]), _vm._v(" "), _c('div', {
    staticClass: "supportEmailId"
  }, [_vm._v("publishingsystem@sciencejournals.ru")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51c6c00c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Admin/Error.vue
// module id = 163
// module chunks = 1